import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

const TrustBoxReviewCount = ({ trustBoxRef, settings }) => (
    /*< !--TrustBox widget - ReviewCollector-- >*/
    <div ref={trustBoxRef} // We need a reference to this element to load the TrustBox in componentDidMount.
        className="trustpilot-widget" // Renamed this to className.
        data-locale={settings.locale} data-template-id="5419b6a8b0d04a076446a9ad"
        data-businessunit-id={settings.trustPilotBusinessUnitId} //"6037915b07033f0001d0198b"
        data-style-height="20px"
        data-style-width="100%">
        <a href={`https://trustpilot.com/review/${settings.customDomain}`} samesite='Secure' target="_blank" rel="noopener">Trustpilot</a>
    </div>
    /*<!--End TrustBox widget-- >*/
);


class TrustBoxContainer extends Component {
    constructor(props) {
        super(props);
        this.trustBoxRef = React.createRef();
    }
    componentDidMount() {
        // If window.Trustpilot is available it means that we need to load the TrustBox from our ref.
        // If it's not, it means the script you pasted into <head /> isn't loaded just yet.
        // When it is, it will automatically load the TrustBox.
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(this.trustBoxRef.current, true);
        }
    }
    render() {
        const { settings } = this.props;
        return <TrustBoxReviewCount trustBoxRef={this.trustBoxRef} settings={settings} />;
    }
}


function mapStateToProps({ settings }) {
    return { settings };
}

export default withTranslation()(connect(mapStateToProps, null, null, { forwardRef: true })(TrustBoxContainer));
